export default __webpack_public_path__ + "static/media/img17.92bd540d.jpg";